import {
  NgpSlider,
  NgpSliderRange,
  NgpSliderThumb,
  NgpSliderTrack,
} from 'ng-primitives/slider';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';

/** Level the mute icon restores to when the slider was dragged all the way
 *  down before muting. */
const DEFAULT_PERCENT = 100;

@Component({
  selector: 'app-chat-sound',
  imports: [
    NgpSlider,
    NgpSliderRange,
    NgpSliderThumb,
    NgpSliderTrack,
    SvgIconComponent,
  ],
  standalone: true,
  templateUrl: './chat-sound.component.html',
  styleUrl: './chat-sound.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSoundComponent {
  /** Master volume as a 0-1 gain (SoundsService unit). */
  volume = input.required<number>();
  changeVolume = output<number>();

  /** The slider works in whole percent; the gain conversion happens on the way
   *  in and out, so a dragged position maps to an actual gain. */
  value = signal<number>(DEFAULT_PERCENT);

  /** Last audible position, so unmuting goes back to where the user left it. */
  private lastAudiblePercent = DEFAULT_PERCENT;

  constructor() {
    effect(() => {
      const percent = this.value();
      if (percent > 0) {
        this.lastAudiblePercent = percent;
      }
      this.changeVolume.emit(percent / 100);
    });
  }

  ngOnInit() {
    this.value.set(Math.round(this.volume() * 100));
  }

  toggleSound() {
    this.value.set(this.value() > 0 ? 0 : this.lastAudiblePercent);
  }
}
